import vmClient from '../../services/vmClient';
import { IExternalAssociation } from '../../types/entity';
import { WordSentence } from './WordSentence';

export const WordSentences: IExternalAssociation = vmClient.defineExternalAssociation({
  typeName: 'WordSentences',
  associationType: WordSentence,
});
